// export const baseUrl = "http://localhost:4000/api/v1";
export const baseUrl = "https://api.kingzbarbershop.pl/api/v1";
